import { render } from "./ValidateInput.vue?vue&type=template&id=194a21f2"
import script from "./ValidateInput.vue?vue&type=script&lang=js"
export * from "./ValidateInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../SINTEZ/OKCU/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__